import { pathOr } from 'ramda';

import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { getUserToken } from '../../ducks/user.duck';
import { sendNextAvailability } from '../../util/api';

// ================ Action Types ================ //

export const UPDATE_AVAILABILITY_REQUEST = 'app/User/UPDATE_AVAILABILITY_REQUEST';
export const UPDATE_AVAILABILITY_SUCCESS = 'app/User/UPDATE_AVAILABILITY_SUCCESS';
export const UPDATE_AVAILABILITY_ERROR = 'app/User/UPDATE_AVAILABILITY_ERROR';

// ================ Reducer ================ //

const initialState = {
  updateInProgress: false,
  updateError: null,
  updateSuccess: false,
};

const availabilityReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_AVAILABILITY_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateError: null,
        updateSuccess: false,
      };
    case UPDATE_AVAILABILITY_SUCCESS:
      return {
        ...state,
        updateInProgress: false,
        updateSuccess: true,
      };
    case UPDATE_AVAILABILITY_ERROR:
      console.error(payload);
      return {
        ...state,
        updateInProgress: false,
        updateError: payload,
        updateSuccess: false,
      };

    default:
      return state;
  }
};

export default availabilityReducer;

// ================ Action Creators ================ //

export const updateAvailabilityRequest = () => ({
  type: UPDATE_AVAILABILITY_REQUEST,
});

export const updateAvailabilitySuccess = () => ({
  type: UPDATE_AVAILABILITY_SUCCESS,
});

export const updateAvailabilityError = e => ({
  type: UPDATE_AVAILABILITY_ERROR,
  error: true,
  payload: e,
});

// ================ Thunk for Updating Availability ================ //

export const updateNextAvailability = (nextAvailability) => async (dispatch, getState, sdk) => {
  dispatch(updateAvailabilityRequest());
  const token = getUserToken();
  return sendNextAvailability({ nextAvailability }, token).then(response => {
    dispatch(fetchCurrentUser());
    dispatch(updateAvailabilitySuccess());
  }).catch(e => {
    dispatch(updateAvailabilityError(storableError(e)));
  });
};

export const loadData = () => (dispatch, getState, sdk) => {
  return Promise.all([dispatch(fetchCurrentUser())])
    .then(response => {
      // const currentUser = getState().user.currentUser;
      // const myFavorites = pathOr([], ['attributes', 'profile', 'protectedData', 'myFavorites'], currentUser);
      // if (currentUser && myFavorites.length > 0) {
      //   dispatch(fetchFavoriteListings(myFavorites));
      // }
      // return response;
    })
    .catch(e => {
      // throw e;
    });
};
